import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

type LatestMoviesProps = {
  movies: Movie[];
  isFavorite: (id: number) => boolean;
  onToggleFavorite: (movie: Movie) => void;
};

export default function LatestMovies({ movies, isFavorite, onToggleFavorite }: LatestMoviesProps) {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-600">
            Latest
          </span>
          <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">最新电影</h2>
          <p className="mt-1.5 text-sm text-foreground-600">
            按上映时间倒序更新的最新作品，点击进入详情页查看完整资料
          </p>
        </div>
        <Link
          to="/category?sort=year"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
        >
          全部作品
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 md:gap-5 lg:grid-cols-5">
        {movies.map((movie, i) => (
          <MovieCard
            key={movie.id}
            movie={movie}
            index={i}
            isFavorite={isFavorite(movie.id)}
            onToggleFavorite={onToggleFavorite}
          />
        ))}
      </div>
    </section>
  );
}